const translations = {
    "en": {
        scheduleAppointment: {
            thisWeekButton: "This Week",
            nextWeekButton: "Next Week",
            todayButton: "Today",
            scheduleButton: "Schedule",
            appointmentNotAvailable: "The appointment slot you selected is no longer available.",
            agentNoAvailability: "This agent has no availability for today.",
            agentNoAvailabilityThisWeek: "This agent has no availability.",
            locationNoAvailability: "This location has no availability for today."
        },
        confirmAppointment: {
            header: "Confirmed!",
            confirm: "You're scheduled for a virtual appointment with {name}",
            email: "We've emailed you the appointment link.",
            email2: "Please follow the instructions to connect at your scheduled time."
        },
        cancelAppointment: {
            header: "CANCELLED!",
            body: "The following appointment has been cancelled:",
            error: "Uh Oh! Looks like this appointment has already been cancelled."
        },
        common: {
            scheduleAppointmentHeader: "Schedule Appointment",
            closeWindow: "Close Window",
            cancelButton: "Cancel"
        },
        dates: {
            today: "Today",
            tomorrow: "Tomorrow",
            daysOfWeek: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
            months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
        }
    },
    "en-au": {
        scheduleAppointment: {
            thisWeekButton: "This Week",
            nextWeekButton: "Next Week",
            todayButton: "Today",
            scheduleButton: "Schedule",
            appointmentNotAvailable: "The appointment slot you selected is no longer available.",
            agentNoAvailability: "This agent has no availability for today.",
            agentNoAvailabilityThisWeek: "This agent has no availability.",
            locationNoAvailability: "This location has no availability for today."
        },
        confirmAppointment: {
            header: "Confirmed!",
            confirm: "You're scheduled for a virtual appointment with {name}",
            email: "We've emailed you the appointment link.",
            email2: "Please follow the instructions to connect at your scheduled time."
        },
        cancelAppointment: {
            header: "CANCELLED!",
            body: "The following appointment has been cancelled:",
            error: "Uh Oh! Looks like this appointment has already been cancelled."
        },
        common: {
            scheduleAppointmentHeader: "Schedule Appointment",
            closeWindow: "Close Window",
            cancelButton: "Cancel"
        },
        dates: {
            today: "Today",
            tomorrow: "Tomorrow",
            daysOfWeek: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
            months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
        }
    },
    "fr-ca": {
        scheduleAppointment: {
            thisWeekButton: "Cette semaine",
            nextWeekButton: "La semaine prochaine",
            todayButton: "Aujourd'hui",
            scheduleButton: "Horaire",
            appointmentNotAvailable: "Le créneau de rendez-vous que vous avez sélectionné n'est plus disponible.",
            agentNoAvailability: "Cet agent n'est pas disponible aujourd'hui.",
            agentNoAvailabilityThisWeek: "Cet agent n'est pas disponible.",
            locationNoAvailability: "Ce lieu n'est pas disponible aujourd'hui."
        },
        confirmAppointment: {
            header: "Confirmé",
            confirm: "Vous avez un rendez-vous virtuel avec {name}",
            email: "Nous vous avons envoyé par courriel le lien pour le rendez-vous.",
            email2: "Veuillez suivre les instructions pour vous connecter à l'heure prévue."
        },
        cancelAppointment: {
            header: "ANNULÉ!",
            body: "Le rendez-vous suivant a été annulé :",
            error: "Oh! Oh! Il semble que ce rendez-vous ait déjà été annulé."
        },
        common: {
            scheduleAppointmentHeader: "Fixer un rendez-vous",
            closeWindow: "Fermer la fenêtre",
            cancelButton: "Annuler"
        },
        dates: {
            today: "Aujourd'hui",
            tomorrow: "Demain",
            daysOfWeek: ["dimanche", "lundi", "mardi", "mercredi", "jeudi", "vendredi", "samedi"],
            months: ["janvier", "février", "mars", "avril", "mai", "juin", "juillet", "août", "septembre", "octobre", "novembre", "décembre"]
        }
    },
    "fr": {
        scheduleAppointment: {
            thisWeekButton: "Cette semaine",
            nextWeekButton: "La semaine prochaine",
            todayButton: "Aujourd'hui",
            scheduleButton: "PROGRAMMER",
            appointmentNotAvailable: "Le créneau de rendez-vous que vous avez sélectionné n'est plus disponible.",
            agentNoAvailability: "Cet agent n'est pas disponible pour aujourd'hui.",
            agentNoAvailabilityThisWeek: "Cet agent n'est pas disponible pour aujourd'hui.",
            locationNoAvailability: "Cet emplacement n'est pas disponible pour aujourd'hui."
        },
        confirmAppointment: {
            header: "Confirmé !",
            confirm: "Vous êtes programmé pour un rendez-vous virtuel avec {name}",
            email: "Nous vous avons envoyé par e-mail le lien du rendez-vous.",
            email2: "Veuillez suivre les instructions pour vous connecter à l'heure prévue."
        },
        cancelAppointment: {
            header: "ANNULÉ !",
            body: "Le rendez-vous suivant a été annulé :",
            error: "Oh ! On dirait que ce rendez-vous a déjà été annulé."
        },
        common: {
            scheduleAppointmentHeader: "PROGRAMMER UN RENDEZ-VOUS",
            closeWindow: "FERMER LA FENÊTRE",
            cancelButton: "Annuler"
        },
        dates: {
            today: "Aujourd'hui",
            tomorrow: "Demain",
            daysOfWeek: ["Dimanche", "Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi"],
            months: ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"]
        }
    },
    "es": {
        scheduleAppointment: {
            thisWeekButton: "Esta semana",
            nextWeekButton: "La próxima semana",
            todayButton: "Hoy",
            scheduleButton: "Calendario",
            appointmentNotAvailable: "El horario de cita que ha seleccionado ya no está disponible.",
            agentNoAvailability: "Este agente no está disponible hoy.",
            agentNoAvailabilityThisWeek: "Este agente no está disponible.",
            locationNoAvailability: "Esta ubicación no está disponible hoy."
        },
        confirmAppointment: {
            header: "¡Confirmado!",
            confirm: "Ha programado su cita virtual con {name}",
            email: "Le hemos enviado un email con el enlace para la cita.",
            email2: "Por favor, siga las instrucciones para conectar a la hora que ha programado."
        },
        cancelAppointment: {
            header: "¡CANCELADA!",
            body: "La siguiente cita ha sido cancelada:",
            error: "¡Vaya! Parece que esta cita ya ha sido cancelada."
        },
        common: {
            scheduleAppointmentHeader: "Cita programada",
            closeWindow: "Cerrar ventana",
            cancelButton: "Cancelar"
        },
        dates: {
            today: "Hoy",
            tomorrow: "Mañana",
            daysOfWeek: ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"],
            months: ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"]
        }
    },
    "it": {
        scheduleAppointment: {
            thisWeekButton: "Questa settimana",
            nextWeekButton: "La prossima settimana",
            todayButton: "Oggi",
            scheduleButton: "PRENOTA",
            appointmentNotAvailable: "L'orario che hai selezionato per l'appuntamento non è più disponibile.",
            agentNoAvailability: "Questo agente non è disponibile oggi.",
            agentNoAvailabilityThisWeek: "Questo agente non è disponibile oggi.",
            locationNoAvailability: "Questa location non ha disponibilità per oggi."
        },
        confirmAppointment: {
            header: "Confermato!",
            confirm: "Hai prenotato un appuntamento virtuale con {name}",
            email: "Ti abbiamo inviato il link dell'appuntamento.",
            email2: "Segui le istruzioni per connetterti all'orario fissato per l'appuntamento."
        },
        cancelAppointment: {
            header: "CANCELLATO!",
            body: "Il seguente appuntamento è stato cancellato:",
            error: "Ops! Sembra che questo appuntamento sia già stato cancellato."
        },
        common: {
            scheduleAppointmentHeader: "PRENOTA APPUNTAMENTO",
            closeWindow: "CHIUDI FINESTRA",
            cancelButton: "Cancella"
        },
        dates: {
            today: "Oggi",
            tomorrow: "Domani",
            daysOfWeek: ["Domenica", "Lunedi", "Martedì", "Mercoledì", "Giovedi", "Venerdì", "Sabato"],
            months: ["Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno", "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"]
        }
    },
    "de": {
        scheduleAppointment: {
            thisWeekButton: "Diese Woche",
            nextWeekButton: "Nächste Woche",
            todayButton: "Heute",
            scheduleButton: "ZEITPLAN",
            appointmentNotAvailable: "Der von Ihnen gewählte Termin ist nicht mehr verfügbar.",
            agentNoAvailability: "Dieser Agent ist für heute nicht verfügbar.",
            agentNoAvailabilityThisWeek: "Dieser Agent ist für heute nicht verfügbar.",
            locationNoAvailability: "Dieser Standort ist für heute nicht verfügbar."
        },
        confirmAppointment: {
            header: "Bestätigt!",
            confirm: "Sie haben einen virtuellen Termin mit {name} vereinbart",
            email: "Wir haben Ihnen den Termin-Link per E-Mail zugeschickt.",
            email2: "Bitte folgen Sie den Anweisungen, um sich zu Ihrer geplanten Zeit zu verbinden."
        },
        cancelAppointment: {
            header: "ABGESAGT!",
            body: "Der folgende Termin wurde abgesagt:",
            error: "Oh! Sieht aus, als wäre dieser Termin bereits abgesagt worden."
        },
        common: {
            scheduleAppointmentHeader: "TERMIN VEREINBAREN",
            closeWindow: "FENSTER SCHLIESSEN",
            cancelButton: "Stornieren"
        },
        dates: {
            today: "Heute",
            tomorrow: "Morgen",
            daysOfWeek: ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"],
            months: ["Januar", "Februar", "März", "April", "Kann", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"]
        }
    },
    "zh": {
        scheduleAppointment: {
            thisWeekButton: "本週",
            nextWeekButton: "下周",
            todayButton: "今天",
            scheduleButton: "預約",
            appointmentNotAvailable: "您選擇的時段已滿",
            agentNoAvailability: "該顧問今天可用時段已滿",
            agentNoAvailabilityThisWeek: "該顧問今天可用時段已滿",
            locationNoAvailability: "該店可用時段已滿"
        },
        confirmAppointment: {
            header: "已確認！",
            confirm: "已為您確認與{name}的視像通話預約",
            email: "我們已透過電子郵件將預約連結發送給您。",
            email2: "請按照說明在您預定的時間進行連線。"
        },
        cancelAppointment: {
            header: "已取消！",
            body: "以下預約已被取消：",
            error: "噢！此預約已被取消。"
        },
        common: {
            scheduleAppointmentHeader: "安排約會",
            closeWindow: "關閉",
            cancelButton: "取消"
        },
        dates: {
            today: "今天",
            tomorrow: "明日",
            daysOfWeek: ["週日", "週一", "週二", "週三", "週四", "週五", "週六"],
            months: ["一月", "二月", "三月", "四月", "五月", "六月", "七月", "八月", "九月", "十月", "十一月", "十二月"]
        }
    },
    "zh-tw": {
        scheduleAppointment: {
            thisWeekButton: "本週",
            nextWeekButton: "下周",
            todayButton: "今天",
            scheduleButton: "時間表",
            appointmentNotAvailable: "您選擇的約會空檔不再可用。",
            agentNoAvailability: "該代理今天不可用。",
            agentNoAvailabilityThisWeek: "該代理不可用。",
            locationNoAvailability: "該位置今天不可用。"
        },
        confirmAppointment: {
            header: "已確認！",
            confirm: "您已安排使用{name}進行虛擬約會",
            email: "我們已透過電子郵件將約會連結發送給您。",
            email2: "請按照說明在您預定的時間進行連接。"
        },
        cancelAppointment: {
            header: "取消！",
            body: "以下約會已被取消：",
            error: "哇！似乎此約會已被取消。"
        },
        common: {
            scheduleAppointmentHeader: "安排會面",
            closeWindow: "關閉窗口",
            cancelButton: "取消"
        },
        dates: {
            today: "今天",
            tomorrow: "明天",
            daysOfWeek: ["週日", "週一", "週二", "週三", "週四", "週五", "週六"],
            months: ["一月", "二月", "三月", "四月", "五月", "六月", "七月", "八月", "九月", "十月", "十一月", "十二月"]
        }
    },
    "id": {
        scheduleAppointment: {
            thisWeekButton: "Minggu ini",
            nextWeekButton: "Minggu depan",
            todayButton: "Hari ini",
            scheduleButton: "Jadwal",
            appointmentNotAvailable: "Slot waktu perjanjian bertemu yang anda pilih tidak lagi tersedia",
            agentNoAvailability: "Agen ini tidak tersedia untuk hari ini.",
            agentNoAvailabilityThisWeek: "Agen ini tidak tersedia",
            locationNoAvailability: "Lokasi ini tidak tersedia untuk hari ini"
        },
        confirmAppointment: {
            header: "Terkonfirmasi!",
            confirm: "Anda telah dijadwalkan untuk perjanjian bertemu virtual dengan {name}",
            email: "Kami telah mengirimkan pranala perjanjian bertemu melalui email/",
            email2: "Silakan ikuti petunjuk untuk terhubung pada waktu yang ditentunkan di perjanjian bertemu."
        },
        cancelAppointment: {
            header: "DIBATALKAN!",
            body: "Perjanjian bertemu berikut ini telah dibatalkan:",
            error: "Aduh! Sepertinya perjanjian bertemu ini telah dibatalkan."
        },
        common: {
            scheduleAppointmentHeader: "Jadwalkan Perjanjian Bertemu",
            closeWindow: "Tutup Jendela",
            cancelButton: "Batal"
        },
        dates: {
            today: "Hari ini",
            tomorrow: "Besok",
            daysOfWeek: ["Minggu", "Senin", "Selasa", "Rabu", "Kamis", "Jumat", "Sabtu"],
            months: ["Januari", "Februari", "Maret", "April", "Mei", "Juni", "Juli", "Agustus", "September", "Oktober", "November", "Desember"]
        }
    },
    "nl": {
        scheduleAppointment: {
            thisWeekButton: "Deze week",
            nextWeekButton: "Volgende week",
            todayButton: "Vandaag",
            scheduleButton: "Afspraakschema",
            appointmentNotAvailable: "De door u gekozen afspraaktijd is niet langer meer beschikbaar.",
            agentNoAvailability: "Deze servicemedewerker heeft  voor vandaag geen afspraaktijd beschikbaar.",
            agentNoAvailabilityThisWeek: "Deze servicemedewerker heeft geen afspraaktijd beschikbaar.",
            locationNoAvailability: "Deze locatie is voor vandaag niet beschikbaar."
        },
        confirmAppointment: {
            header: "Bevestigd!",
            confirm: "U heeft een virtuele afspraak met {name} gemaakt",
            email: "We hebben u de afspraaklink gemaild.",
            email2: "Gelieve de instructies te volgen om op de afgesproken tijd verbinding te maken"
        },
        cancelAppointment: {
            header: "GEANNULEERD!",
            body: "De volgende afspraak is geannuleerd:",
            error: "Oeps, het lijkt erop dat deze afspraak al is geannuleerd."
        },
        common: {
            scheduleAppointmentHeader: "Afspraak maken",
            closeWindow: "Venster sluiten",
            cancelButton: "Annuleren"
        },
        dates: {
            today: "Vandaag",
            tomorrow: "Morgen",
            daysOfWeek: ["Zondag", "Maandag", "Dinsdag", "Woensdag", "Donderdag", "Vrijdag", "Zaterdag"],
            months: ["Januari", "Februari", "Maart", "April", "Mei", "Juni", "Juli", "Augustus", "September", "Oktober", "November", "December"]
        }
    },
    "ja": {
        scheduleAppointment: {
            thisWeekButton: "今週",
            nextWeekButton: "次の週",
            todayButton: "今日",
            scheduleButton: "予約する",
            appointmentNotAvailable: "申し訳ありません。空きがございません。",
            agentNoAvailability: "予約できる空き枠がございません。",
            agentNoAvailabilityThisWeek: "予約できる空き枠がございません。",
            locationNoAvailability: "予約できる空き枠がございません。"
        },
        confirmAppointment: {
            header: "ご予約が完了しました",
            confirm: "内容をご確認ください {name}",
            email: "ご予約のメールをお送りしました。",
            email2: "お時間になりましたら、PCまたはスマホから確認メールのリンクを押してページへお入りください。"
        },
        cancelAppointment: {
            header: "キャンセルされました",
            body: "以下のご予約はキャンセルされました。",
            error: "このご予約は既にキャンセルされております。"
        },
        common: {
            scheduleAppointmentHeader: "カウンセリングを予約する",
            closeWindow: "閉じる",
            cancelButton: "戻る"
        },
        dates: {
            today: "今日",
            tomorrow: "明日",
            daysOfWeek: ["日曜日", "月曜日", "火曜日", "水曜日", "木曜日", "金曜日", "土曜日"],
            months: ["1月", "2月", "3月", "4月", "5月", "6月", "7月", "8月", "9月", "10月", "11月", "12月"]
        }
    },
    "ko": {
        scheduleAppointment: {
            thisWeekButton: "이번주",
            nextWeekButton: "다음 주",
            todayButton: "오늘",
            scheduleButton: "일정",
            appointmentNotAvailable: "선택한 약속 시간대는 더 이상 이용할 수 없습니다.",
            agentNoAvailability: "이 에이전트는 오늘 이용할 수 없습니다.",
            agentNoAvailabilityThisWeek: "이 에이전트는 이용할 수 없습니다.",
            locationNoAvailability: "이 위치는 오늘 이용할 수 없습니다."
        },
        confirmAppointment: {
            header: "확인되었습니다!",
            confirm: "{name} 님과의 가상 약속이 예약되었습니다.",
            email: "예약 링크를 이메일로 보냈습니다.",
            email2: "예정된 시간에 연결하려면 지침을 따르십시오."
        },
        cancelAppointment: {
            header: "취소되었습니다!",
            body: "다음 약속이 취소되었습니다:",
            error: "이런! 이 약속은 이미 취소된 것 같습니다."
        },
        common: {
            scheduleAppointmentHeader: "일정 예약",
            closeWindow: "창 닫기",
            cancelButton: "취소"
        },
        dates: {
            today: "오늘",
            tomorrow: "내일",
            daysOfWeek: ["일요일", "월요일", "화요일", "수요일", "목요일", "금요일", "토요일"],
            months: ["1 월", "2 월", "3 월", "4 월", "5 월", "6 월", "7 월", "8 월", "9 월", "10 월", "11 월", "12 월"]
        }
    },
    "ru": {
        scheduleAppointment: {
            thisWeekButton: "Эта неделя",
            nextWeekButton: "На следующей неделе",
            scheduleButton: "График",
            appointmentNotAvailable: "Выбранный вами интервал встречи больше не доступен.",
            agentNoAvailability: "Этот агент сейчас недоступен.",
            agentNoAvailabilityThisWeek: "У этого агента нет свободных мест.",
            locationNoAvailability: "На сегодня это место недоступно."
        },
        confirmAppointment: {
            header: "Подтверждено!",
            confirm: "У вас назначена виртуальная встреча с {name}",
            email: "Мы отправили вам ссылку на прием по электронной почте.",
            email2: "Следуйте инструкциям, чтобы подключиться в назначенное время."
        },
        cancelAppointment: {
            header: "ОТМЕНА!",
            body: "Следующая запись отменена:",
            error: "Ой! Похоже, эта встреча уже отменена."
        },
        common: {
            scheduleAppointmentHeader: "Назначить встречу",
            closeWindow: "Закрыть окно",
            cancelButton: "Отмена"
        },
        dates: {
            today: "Cегодня",
            tomorrow: "Завтра",
            daysOfWeek: ["воскресенье", "понедельник", "вторник", "среда", "четверг", "пятница", "суббота"],
            months: ["Январь", "Февраль", "Март", "Апрель", "Май", "Июнь", "Июль", "Август", "Сентябрь", "Октябрь", "Ноябрь", "Декабрь"]
        }
    },
    "da": {
        scheduleAppointment: {
            thisWeekButton: "Denne uge",
            nextWeekButton: "Næste uge",
            todayButton: "I dag",
            scheduleButton: "Tidsplan",
            appointmentNotAvailable: "Det valgte aftaletidspunkt er ikke længere tilgængeligt.",
            agentNoAvailability: "Denne agent har ingen tilgængelighed i dag.",
            agentNoAvailabilityThisWeek: "Denne agent har ingen tilgængelighed.",
            locationNoAvailability: "Denne placering er ikke tilgængelig i dag."
        },
        confirmAppointment: {
            header: "Bekræftet!",
            confirm: "Du har en planlagt, virtuel aftale med {name}",
            email: "Vi har sendt aftalelinket til dig i en mail.",
            email2: "Følg instruktionerne for på dit planlagte tidspunkt at oprette forbindelse ."
        },
        cancelAppointment: {
            header: "ANNULERET!",
            body: "Følgende aftale er annulleret:",
            error: "Åh åh! Det ser ud til, at denne aftale allerede er blevet annulleret."
        },
        common: {
            scheduleAppointmentHeader: "Planlæg aftale",
            closeWindow: "Luk vinduet",
            cancelButton: "Annuler"
        },
        dates: {
            today: "I dag",
            tomorrow: "I morgen",
            daysOfWeek: ["Søndag", "Mandag", "Tirsdag", "Onsdag", "Torsdag", "Fredag", "Lørdag"],
            months: ["Januar", "Februar", "Marts", "April", "Maj", "Juni", "Juli", "August", "September", "Oktober", "November", "December"]
        }
    },
    "no": {
        scheduleAppointment: {
            thisWeekButton: "Denne uken",
            nextWeekButton: "Neste uke",
            todayButton: "I dag",
            scheduleButton: "Tidsplan",
            appointmentNotAvailable: "Avtaletidspunktet du valgte er ikke lenger tilgjengelig.",
            agentNoAvailability: "Denne agenten har ingen tilgjengelighet i dag.",
            agentNoAvailabilityThisWeek: "Denne agenten har ingen tilgjengelighet.",
            locationNoAvailability: "Denne lokasjonen har ingen tilgjengelighet i dag."
        },
        confirmAppointment: {
            header: "Bekreftet!",
            confirm: "Du har avtalt et virtuelt møte med {name}",
            email: "Vi har sendt deg en e-post med avtale-lenken.",
            email2: "Vennligst følg instruksjonene for å koble til på det avtalte tidspunktet."
        },
        cancelAppointment: {
            header: "AVBRUTT!",
            body: "Følgende avtale er kansellert:",
            error: "Oops! Det ser ut til at denne avtalen allerede er kansellert."
        },
        common: {
            scheduleAppointmentHeader: "Bestill time",
            closeWindow: "Lukk vindu",
            cancelButton: "Avbryt"
        },
        dates: {
            today: "I dag",
            tomorrow: "I morgen",
            daysOfWeek: ["Søndag", "Mandag", "Tirsdag", "Onsdag", "Torsdag", "Fredag", "Lørdag"],
            months: ["Januar", "Februar", "Mars", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Desember"]
        }
    },
    "sv": {
        scheduleAppointment: {
            thisWeekButton: "Denna vecka",
            nextWeekButton: "Nästa vecka",
            todayButton: "Idag",
            scheduleButton: "Schema",
            appointmentNotAvailable: "Mötestiden du valt är inte längre tillgänglig",
            agentNoAvailability: "Agenten är inte tillgänglig idag",
            agentNoAvailabilityThisWeek: "Agenten är inte tillgänglig",
            locationNoAvailability: "Platsen är inte tillgänglig idag"
        },
        confirmAppointment: {
            header: "Bekräftad!",
            confirm: "Du har bokat ett digitalt möte med {name}",
            email: "Vi har skickat en möteslänk till din e-post",
            email2: "Följ instruktionerna i mailet för att ansluta till mötet vid bokad tid."
        },
        cancelAppointment: {
            header: "AVBOKAD!",
            body: "Följande möte har avbokats:",
            error: "Onej! Det ser ut som om mötet redan avbokats."
        },
        common: {
            scheduleAppointmentHeader: "Schemalägg möte",
            closeWindow: "Stäng fönster",
            cancelButton: "Avbryt"
        },
        dates: {
            today: "Idag",
            tomorrow: "Imorgon",
            daysOfWeek: ["Söndag", "Måndag", "Tisdag", "Onsdag", "Torsdag", "Fredag", "Lördag"],
            months: ["Januari", "Februari", "Mars", "April", "Maj", "Juni", "Juli", "Augusti", "September", "Oktober", "November", "December"]
        }
    },
    "pt": {
        scheduleAppointment: {
            thisWeekButton: "Esta semana",
            nextWeekButton: "Semana que vem",
            todayButton: "Hoje",
            scheduleButton: "AGENDAR",
            appointmentNotAvailable: "O horário da marcação que selecionou já não está disponível.",
            agentNoAvailability: "Este agente não tem disponibilidade para hoje.",
            agentNoAvailabilityThisWeek: "Este agente não tem disponibilidade para hoje.",
            locationNoAvailability: "Esta localização não tem disponibilidade para hoje."
        },
        confirmAppointment: {
            header: "Confirmado!",
            confirm: "Está agendada uma consulta virtual com {name}",
            email: "Enviámos-lhe o link da marcação.",
            email2: "Por favor siga as instruções para se ligar na hora marcada."
        },
        cancelAppointment: {
            header: "CANCELADA!",
            body: "A seguinte marcação foi cancelada:",
            error: "Ups! Parece que esta marcação já foi cancelada."
        },
        common: {
            scheduleAppointmentHeader: "FAZER MARCAÇÃO",
            closeWindow: "FECHAR JANELA",
            cancelButton: "Cancelar"
        },
        dates: {
            today: "Hoje",
            tomorrow: "Amanhã",
            daysOfWeek: ["Domingo", "Segunda-feira", "Terça", "Quarta-feira", "Quinta-feira", "Sexta-feira", "Sábado"],
            months: ["Janeiro", "Fevereiro", "Março", "Abril", "Posso", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"]
        }
    },
    "ar": {
        scheduleAppointment: {
            thisWeekButton: "هذا الأسبوع",
            nextWeekButton: "الأسبوع المقبل",
            todayButton: "اليوم",
            scheduleButton: "جدول",
            appointmentNotAvailable: "خانة الموعد التي اخترتها لم تعد متاحة",
            agentNoAvailability: "هذا العميل غير متاح اليوم",
            agentNoAvailabilityThisWeek: "هذا العميل غير متاح",
            locationNoAvailability: "هذا الموقع غير متاح اليوم"
        },
        confirmAppointment: {
            header: "تم التأكيد!",
            confirm: "لديك موعد مقابلة افتراضية مع {name}",
            email: "لقد قمنا بإرسال رابط الموعد عن طريق البريد الإلكتروني",
            email2: "يرجى تتبع التعليمات للتواصل في الوقت المحدد لك."
        },
        cancelAppointment: {
            header: "ملغى!",
            body: "تم إلغاء الموعد التالي:",
            error: "للأسف! يبدو أن هذا الموعد قد ألغي بالفعل."
        },
        common: {
            scheduleAppointmentHeader: "جدول موعد",
            closeWindow: "أغلق النافذة",
            cancelButton: "ألغٍ"
        },
        dates: {
            today: "اليوم",
            tomorrow: "غداَ",
            daysOfWeek: ["الأحد", "الإثنين", "الثلاثاء", "الأربعاء", "الخميس", "الجمعة", "السبت"],
            months: ["يناير", "فبراير", "مارس", "أبريل", "مايو", "يونيو", "يوليو", "أغسطس", "سبتمبر", "أوكتوبر", "نوفمبر", "ديسمبر"]
        }
    },
    "th": {
        scheduleAppointment: {
            thisWeekButton: "สัปดาห์นี้",
            nextWeekButton: "สัปดาห์หน้า",
            todayButton: "วันนี้",
            scheduleButton: "ตารางเวลา",
            appointmentNotAvailable: "ช่วงเวลานัดหมายที่เลือกไว้ไม่มีตารางว่างอีกต่อไป",
            agentNoAvailability: "ตัวแทนนี้ไม่มีตารางเวลาว่างสำหรับวันนี้",
            agentNoAvailabilityThisWeek: "ตัวแทนนี้ไม่มีตารางเวลาว่าง",
            locationNoAvailability: "สถานที่ตั้งนี้ไม่มีเวลาว่างสำหรับวันนี้"
        },
        confirmAppointment: {
            header: "ยืนยันแล้ว!",
            confirm: "คุณได้รับการกำหนดตารางเวลาสำหรับการนัดหมายเสมือนจริงกับ {name} แล้ว",
            email: "เราได้ส่งอีเมลลิงก์ตารางนัดหมายไปถึงคุณแล้ว",
            email2: "โปรดปฏิบัติตามคำแนะนำเพื่อเชื่อมต่อตามเวลานัดหมายของคุณ"
        },
        cancelAppointment: {
            header: "ยกเลิกแล้ว!",
            body: "การนัดหมายดังต่อไปนี้ได้รับการยกเลิกแล้ว:",
            error: "โอ้ ไม่! ดูเหมือนว่าการนัดหมายนี้ได้รับการยกเลิกไปแล้ว"
        },
        common: {
            scheduleAppointmentHeader: "ตารางการนัดหมาย",
            closeWindow: "ปิดหน้าต่าง",
            cancelButton: "ยกเลิก"
        },
        dates: {
            today: "วันนี้",
            tomorrow: "พรุ่งนี้",
            daysOfWeek: ["วันอาทิตย์", "วันจันทร์", "วันอังคาร", "วันพุธ", "วันพฤหัสบดี", "วันศุกร์", "วันเสาร์"],
            months: ["มกราคม", "กุมภาพันธ์", "มีนาคม", "เมษายน", "พฤษภาคม", "มิถุนายน", "กรกฏาคม", "สิงหาคม", "กันยายน", "ตุลาคม", "พฤศจิกายน", "ธันวาคม"]
        }
    },
    "ms": {
        scheduleAppointment: {
            thisWeekButton: "Minggu ini",
            nextWeekButton: "Minggu depan",
            todayButton: "Hari ini",
            scheduleButton: "Jadual",
            appointmentNotAvailable: "Slot temu janji yang anda pilih tidak lagi didapati.",
            agentNoAvailability: "Ejen ini tidak didapati untuk hari ini.",
            agentNoAvailabilityThisWeek: "Ejen ini tidak didapati.",
            locationNoAvailability: "Lokasi ini tidak didapati untuk hari ini."
        },
        confirmAppointment: {
            header: "Disahkan!",
            confirm: "Anda dijadualkan untuk temu janji maya dengan {name}",
            email: "Kami telah menghantar pautan temu janji melalui e-mel kepada anda.",
            email2: "Sila ikuti arahan untuk bersambung pada waktu yang dijadualkan."
        },
        cancelAppointment: {
            header: "DIBATALKAN!",
            body: "Temu janji berikut telah dibatalkan:",
            error: "Uh Oh! Nampaknya temu janji ini telah dibatalkan."
        },
        common: {
            scheduleAppointmentHeader: "Jadualkan Jemu Janji",
            closeWindow: "Tutup Tetingkap",
            cancelButton: "Batal"
        },
        dates: {
            today: "Hari ini",
            tomorrow: "Esok",
            daysOfWeek: ["Ahad", "Isnin", "Selasa", "Rabu", "Khamis", "Jumaat", "Sabtu"],
            months: ["Januari", "Februari", "Mac", "April", "Mei", "Jun", "Julai", "Ogos", "September", "Oktober", "November", "Disember"]
        }
    },
    "he": {
        scheduleAppointment: {
            thisWeekButton: "השבוע",
            nextWeekButton: "שבוע הבא",
            todayButton: "היום",
            scheduleButton: "לוח זמנים",
            appointmentNotAvailable: "משבצת הפגישות שבחרת אינה זמינה יותר.",
            agentNoAvailability: "לסוכן זה אין זמינות להיום.",
            agentNoAvailabilityThisWeek: "לסוכן זה אין זמינות.",
            locationNoAvailability: "למיקום זה אין זמינות להיום."
        },
        confirmAppointment: {
            header: "אושר!",
            confirm: "נקבעה פגישה וירטואלית עם {name}",
            email: "שלחנו לך בדוא\"ל את הקישור לפגישה.",
            email2: "אנא עקוב אחר ההוראות להתחברות בזמן המתוזמן."
        },
        cancelAppointment: {
            header: "בוטל!",
            body: "התור הבא בוטל:",
            error: "אוי לא! נראה שהפגישה הזו כבר בוטלה."
        },
        common: {
            scheduleAppointmentHeader: "קבע פגישה",
            closeWindow: "סגור חלון",
            cancelButton: "בטל"
        },
        dates: {
            today: "היום",
            tomorrow: "מחר",
            daysOfWeek: ["ראשון", "שני", "שלישי", "רביעי", "חמישי", "שישי", "שבת"],
            months: ["ינואר", "פברואר", "מרץ", "אפריל", "מאי", "יוני", "יולי", "אוגוסט", "ספטמבר", "אוקטובר", "נובמבר", "דצמבר"]
        }
    },
}

export default translations;